module.exports = "/_next/static/images/question-c0ea416267b9cf08e480c873e27f72dc.svg";